
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ValueCell extends Vue {
  @Prop({ default: undefined })
  value!: any;

  get hasValue(): boolean {
    return !!this.value && this.value !== null && this.value !== undefined;
  }
}
